import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../../PicesForPages/LogoPrimeHomeMortgageIcon.png";
import menuButton from "../../PicesForPages/menu.png";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className="headerParent">
      <div className="headerBox">
        <Link to="/" className="headerLogoDiv">
          <img
            fetchPriority="high"
            loading="eager"
            src={Logo}
            alt="Logo"
            className="headerLogo"
          />
          <p className="LogoNmlsNo">NMLS # 2658067</p>
        </Link>
        <div className="headerMenu">
          <Link to="/todays-rates" className="headerMenuUI_Header">
            Todays Rates
          </Link>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Purchase &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link to="/purchase">Purchase</Link>
              </li>
              <li>
                <Link to="/paper-work">PaperWork Needed</Link>
              </li>
              <li>
                <Link to="/how-much-can-i-afford-calculator">
                  How Much Can I Afford?
                </Link>
              </li>
              {/* <li>How Much Can I Afford?</li> */}
              <li>
                <Link to="/what-will-my-monthly-payment-be-calculator">
                  Calculate Monthly Payments
                </Link>
              </li>
              <li>
                <Link to="/quick-quote">Instant Loan Quote</Link>
              </li>
              <li>
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                  target="_blank"
                >
                  Apply
                </Link>
              </li>
              <li>
                <Link to="/fha">FHA Mortgages</Link>
              </li>
              <li>
                <Link to="/va-loans">VA Mortgages</Link>
              </li>
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Refinance &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link to="/refinancing">Refinance Your Loan</Link>
              </li>
              <li>
                <Link to="/cash-out-refinance">Cash Out Refinance</Link>
              </li>
              <li>
                <Link to="/refinance-analysis-calculator">
                  Loan Analysis for Refinancing
                </Link>
              </li>
              <li>
                <Link to="/quick-quote">Instant Loan Quote</Link>
              </li>
              <li>
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                  target="_blank"
                >
                  Apply
                </Link>
              </li>
              <li>
                <Link to="/fha-va-streamline">
                  FHA/VA Refinancing Simplified
                </Link>
              </li>
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Reports &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link to="/free-reports">Access Free Detailed Reports</Link>
              </li>
              <li>
                <Link to="/how-much-can-i-afford-calculator">
                  How Much Can I Afford?
                </Link>
              </li>
              <li>
                <Link to="/what-will-my-monthly-payment-be-calculator">
                  Calculate Monthly Payments
                </Link>
              </li>
              <li>
                <Link to="renting-versus-buying-calculator">
                  Rent vs Buy Comparison Tool
                </Link>
              </li>
              <li>
                <Link to="/refinance-analysis-calculator">
                  Refinance Evaluation Tool
                </Link>
              </li>
              <li>
                <Link to="/debt-consolidation-calculator">
                  Consolidation Calculator
                </Link>
              </li>
              <li>
                <Link to="/paper-work">PaperWork Needed</Link>
              </li>
              <li>
                <Link to="/the-loan-process">Mortgage Loan Process</Link>
              </li>
              <li>
                <Link to="/glossary-terms">Mortgage Terminology Glossary</Link>
              </li>
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Contact &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                  target="_blank"
                >
                  Apply
                </Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/our-family">Meet Our Family</Link>
              </li>
              <li>
                <Link to="/join-our-Family">Join Our Family</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </span>
          </ul>
          <a href="tel:+1-833-745-6684" className="headerMenu_Tel">
            {/* (980) 292-1918 */}
            (833) 745-6684
          </a>

          <Link
            to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
            target="_blank"
          >
            <button className="headerMenuButton">Apply</button>
          </Link>

          {/* Deleted-Testing code for customr details are sent Gmail through FORM  */}
          {/* <span className='headerMenuUI_Header'><Link to="/test-mail-through-form">TestMailThroughForm</Link></span> */}
        </div>
        <div className="headerMenuMobileView">
          {/* <ul className='headerMenuUI headerMenuUI00'>
                        <span className='headerMenuUI_Header'>Reports &#x025BF;</span>
                        <span className='headerMenuUI_LI headerMenuUI_LI00' >
                            <li><Link to="/free-reports">Access Free Detailed Reports</Link></li>
                            <li><Link to="/how-much-can-i-afford-calculator">How Much Can I Afford?</Link></li>
                            <li><Link to="/what-will-my-monthly-payment-be-calculator">Calculate Monthly Payments</Link></li>
                            <li><Link to="renting-versus-buying-calculator">Rent vs Buy Comparison Tool</Link></li>
                            <li><Link to="/refinance-analysis-calculator">Refinance Evaluation Tool</Link></li>
                            <li><Link to="/debt-consolidation-calculator">Consolidation Calculator</Link></li>
                            <li><Link to="/paper-work">PaperWork Needed</Link></li>
                            <li><Link to="/the-loan-process">Mortgage Loan Process</Link></li>
                            <li><Link to="/glossary-terms">Mortgage Terminology Glossary</Link></li>
                        </span>
                    </ul> */}
          {!menuOpen ? (
            <img
              fetchPriority="high"
              loading="eager"
              src={menuButton}
              alt="Menu Button"
              id="menubtn"
              onClick={toggleMenu}
            />
          ) : (
            <span id="closebtn" onClick={toggleMenu}>
              X
            </span>
          )}
          {menuOpen && (
            <div
              className="headerMenuMobileView headerMenuMobileViewlist"
              ref={menuRef}
            >
              <Link
                to="/todays-rates"
                className="headerMenuUI_Header"
                onClick={toggleMenu}
              >
                Todays Rates
              </Link>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Purchase &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link to="/purchase" onClick={toggleMenu}>
                      Purchase
                    </Link>
                  </li>
                  <li>
                    <Link to="/paper-work" onClick={toggleMenu}>
                      PaperWork Needed
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/how-much-can-i-afford-calculator"
                      onClick={toggleMenu}
                    >
                      How Much Can I Afford?
                    </Link>
                  </li>
                  {/* <li>How Much Can I Afford?</li> */}
                  <li>
                    <Link
                      to="/what-will-my-monthly-payment-be-calculator"
                      onClick={toggleMenu}
                    >
                      Calculate Monthly Payments
                    </Link>
                  </li>
                  <li>
                    <Link to="/quick-quote" onClick={toggleMenu}>
                      Instant Loan Quote
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                      target="_blank"
                      onClick={toggleMenu}
                    >
                      Apply
                    </Link>
                  </li>
                  <li>
                    <Link to="/fha" onClick={toggleMenu}>
                      FHA Mortgages
                    </Link>
                  </li>
                  <li>
                    <Link to="/va-loans" onClick={toggleMenu}>
                      VA Mortgages
                    </Link>
                  </li>
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Refinance &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link to="/refinancing" onClick={toggleMenu}>
                      Refinance Your Loan
                    </Link>
                  </li>
                  <li>
                    <Link to="/cash-out-refinance" onClick={toggleMenu}>
                      Cash Out Refinance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/refinance-analysis-calculator"
                      onClick={toggleMenu}
                    >
                      Loan Analysis for Refinancing
                    </Link>
                  </li>
                  <li>
                    <Link to="/quick-quote" onClick={toggleMenu}>
                      Instant Loan Quote
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                      target="_blank"
                      onClick={toggleMenu}
                    >
                      Apply
                    </Link>
                  </li>
                  <li>
                    <Link to="/fha-va-streamline" onClick={toggleMenu}>
                      FHA/VA Refinancing Simplified
                    </Link>
                  </li>
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Reports &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <Link to="/free-reports" onClick={toggleMenu}>
                      Access Free Detailed Reports
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/how-much-can-i-afford-calculator"
                      onClick={toggleMenu}
                    >
                      How Much Can I Afford?
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/what-will-my-monthly-payment-be-calculator"
                      onClick={toggleMenu}
                    >
                      Calculate Monthly Payments
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="renting-versus-buying-calculator"
                      onClick={toggleMenu}
                    >
                      Rent vs Buy Comparison Tool
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/refinance-analysis-calculator"
                      onClick={toggleMenu}
                    >
                      Refinance Evaluation Tool
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/debt-consolidation-calculator"
                      onClick={toggleMenu}
                    >
                      Consolidation Calculator
                    </Link>
                  </li>
                  <li>
                    <Link to="/paper-work" onClick={toggleMenu}>
                      PaperWork Needed
                    </Link>
                  </li>
                  <li>
                    <Link to="/the-loan-process" onClick={toggleMenu}>
                      Mortgage Loan Process
                    </Link>
                  </li>
                  <li>
                    <Link to="/glossary-terms" onClick={toggleMenu}>
                      Mortgage Terminology Glossary
                    </Link>
                  </li>
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">Contact &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  {/* <li><Link to='' onClick={toggleMenu}>Apply</Link></li> */}
                  <li>
                    <Link
                      to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                      target="_blank"
                      onClick={toggleMenu}
                    >
                      Apply
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us" onClick={toggleMenu}>
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-family" onClick={toggleMenu}>
                      Meet Our Family
                    </Link>
                  </li>
                  <li>
                    <Link to="/join-our-Family" onClick={toggleMenu}>
                      Join Our Family
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact-us" onClick={toggleMenu}>
                      Contact Us
                    </Link>
                  </li>
                </span>
              </ul>
              <a href="tel:+1-833-745-6684" className="headerMenu_Tel">
                <i class="ri-phone-fill"></i> (833) 745-6684
              </a>

              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                target="_blank"
              >
                <button className="headerMenuButton">Apply</button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
